<template>
    <v-navigation-drawer
            v-model="drawer"
            permanent
            absolute
    >
        <v-toolbar flat class="transparent">
            <v-list class="pa-0" v-if="user">
                <v-list-tile avatar>
                    <v-list-tile-avatar>
                        <img :src="user.avatar">
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                        <v-list-tile-title>{{ user.displayName }}</v-list-tile-title>
                        <v-list-tile-sub-title @click="logout">
                            <a class="logout">{{ $t('login.logout') }}</a>
                        </v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-toolbar>

        <v-list class="pt-0" dense>
            <v-divider></v-divider>
            <v-list-tile
                    v-for="route in routes"
                    :key="route.path"
                    :to="route.path">
                <v-list-tile-action>
                    <v-icon>{{ route.icon }}</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title>{{ $t(`routes.${route.title}`) }}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "SideMenu",
        data() {
            return {
                drawer: true,
                mini: false,
                routes: [
                    {
                        title: 'gcpProjects',
                        icon: 'view_list',
                        path: '/gcp-projects'
                    },
                    {
                        title: 'firebaseProjects',
                        icon: 'view_list',
                        path: '/firebase-projects'
                    }
                ]
            }
        },
        computed: {
            ...mapGetters({
                user: "authentication/user",
            }),
        },
        methods: {
            logout() {
                this.$store.dispatch('authentication/clear');
                location.replace('/login');
            }
        }
    }
</script>

<style>
    .logout {
        cursor: pointer !important;
        color: grey;
    }
</style>
